import { render, staticRenderFns } from "./SearchSongResults.vue?vue&type=template&id=1c84fe7e&scoped=true&"
import script from "./SearchSongResults.vue?vue&type=script&lang=js&"
export * from "./SearchSongResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c84fe7e",
  null
  
)

export default component.exports